import { cache } from '@/container/apollo-client/cache';
import { QUERY_GET_NOTIFICATIONS } from '@/graphql/cursor.graphql';
import { QUERY_GET_NOTIFICATION_COUNT } from '@/graphql/query.graphql';
import {
  GetAllNotificationV2Query,
  NotificationV2,
  ObtainNotificationCountQuery,
  useNotificationSubscriptionSubscription,
} from '@/types/generated/graphql';
import { useMatch } from 'react-router-dom';

export function useNotificationSubscriptions() {
  const matchClientConversation = useMatch({
    path: '/conversations/:channelId/:clientId?', // `?` makes clientId optional and handles the case in which there is no clientId
    end: false,
  });
  const matchMemberConversation = useMatch({
    path: '/conversations/member/:memberId',
    end: false,
  });

  useNotificationSubscriptionSubscription({
    onData: ({ data }) => {
      const memberId = matchMemberConversation?.params?.memberId ?? '';
      const channelId = matchClientConversation?.params?.channelId + '';
      const clientId = matchClientConversation?.params?.clientId + '';

      const subscriptionMemberId =
        data?.data?.notificationSubscription?.notification?.redirection?.params?.memberId + '';
      const subscriptionChannelId =
        data?.data?.notificationSubscription?.notification?.redirection?.params?.channelId + '';
      const subscriptionClientId =
        data?.data?.notificationSubscription?.notification?.redirection?.params?.clientId + '';
      const isMemberChatOpen = memberId === subscriptionMemberId;
      const isClientChatOpen = clientId === subscriptionClientId && channelId === subscriptionChannelId;

      if (isMemberChatOpen || isClientChatOpen) return;
      const newCount = data?.data?.notificationSubscription?.counter ?? 0;
      const newNotification = data?.data?.notificationSubscription?.notification as NotificationV2;
      appendNewNotificationToList(newNotification);
      increaseNotificationCount(newCount);
    },
  });

  function appendNewNotificationToList(newNotification: NotificationV2) {
    cache.updateQuery<GetAllNotificationV2Query>({ query: QUERY_GET_NOTIFICATIONS }, (data) => {
      if (data) {
        return {
          ...data,
          getAllNotificationV2: {
            ...data?.getAllNotificationV2,
            data: [newNotification, ...(data?.getAllNotificationV2?.data || [])],
          },
        };
      }
      return data;
    });
  }

  function increaseNotificationCount(newCount: number) {
    cache.updateQuery<ObtainNotificationCountQuery>({ query: QUERY_GET_NOTIFICATION_COUNT }, (data) => {
      return {
        ...data,
        obtainNotificationCount: {
          ...data?.obtainNotificationCount,
          data: {
            ...data?.obtainNotificationCount?.data,
            count: newCount,
          },
        },
      };
    });
  }
}
